module.exports = __webpack_public_path__ + "img/发色变换--大图gif.7f64049c.gif";